module.exports = __webpack_public_path__ + "static/media/Hybrid.06904b40.svg";